// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Ox9z","header":"ReportDetails_header__2bsYF","title":"ReportDetails_title__2Nih4","left":"ReportDetails_left__gWkMT"};